<template>
    <div class="layer-list-container">
        <div class="data-panel">
            <b-row no-gutters>
                <b-col cols="12" class="layer-list-font">Road Features</b-col>
            </b-row>
        </div>
        <div class="layers">
            <draggable>
                <transition-group type="transition" name="flip-list">
                    <b-row v-for="(element, index) in drtLayersButtonsCtrl" :key="element.name" :id="element.name"
                        class="layer-row" :class="getLayerClass(index, element)">
                        <b-col cols="8" class="layer-btn"
                            :class="getLayerClass(index, element)" @click="toggleLayer(element, $event)">
                            <span class="layer-row-label">{{ element.display_name ? element.display_name : element.name }}</span>
                        </b-col>
                        <b-col cols="4" class="layer-arrow layer-arrow--end">
                            <fa @click="toTopOfList(element.display_name ? element.display_name : element.name)"
                                title="Move Layer To Top" :icon="['fas', 'long-arrow-alt-up']" class="cursor" />
                        </b-col>
                    </b-row>
                </transition-group>
            </draggable>
        </div>
        <AI_LayerLegend v-if="layerLegend" id="layerLegend" class="layer-legend-position p-1"
            :layerLegendMaxHeight="layerLegendMaxHeight" :layerLegendName="layerLegendName" :legendImgSrc="legendImgSrc"
            :legendMinimized="layerLegendMinimized" @closeLegend="closeLegend()" @maximizeLegend="maxOrMinLegend(false)"
            @minimizeLegend="maxOrMinLegend(true)"></AI_LayerLegend>
    </div>
</template>
<style src="./Spatial_Intelligence.css" scoped></style>
<style scoped>
.layer-list-container {
    /* border: 2px solid #063c6d; */
    height: auto;
    width: 200px;
    border-radius: 5px;
    overflow: hidden;
}

.data-panel {
    width: 100%;
    background-color: #063c6d;
    color: white;
    padding: 5%;
}

.layer-list-font {
    font-size: 15px !important;
    font-weight: 500;
}

.change-database-text {
    position: absolute;
    color: #20ff9b;
    cursor: pointer;
    font-size: 12px !important;
    -webkit-user-select: none;
    /* Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+/Edge */
    user-select: none;
    /* Standard */
    width: 100%;
    right: 5px;
    text-align: right;
}

.layers {
    width: 100%;
    padding: 4px 4px;
    background-color: #eef3f9;
}

.layer-btn {
    font-size: 14px !important;
    font-weight: 500;
    width: 100%;
    padding: 6px 10px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    min-width: 0;
    color: #063c6d;
}

.layer-row-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px !important;
}

.layer-arrow--end {
  justify-content: flex-end;
  padding-right: 12px;
}

.layer-arrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #063c6d;
    cursor: pointer !important;
}

.layer-row {
    padding: 0 !important;
    margin: 0 0 8px;
    width: 100%;
    min-height: 44px;
    background-color: #ffffff;
    border: 1px solid rgba(6, 60, 109, 0.1);
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(6, 60, 109, 0.06);
    overflow: hidden;
    cursor: pointer !important;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.layer-row:last-child {
    margin-bottom: 0;
}

.layer-row:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(6, 60, 109, 0.14);
    border-color: rgba(6, 60, 109, 0.2);
}

.available-not-enabled {
    background-color: #ffffff;
}

.available-enabled {
     background-color: #c4ead2;
    box-shadow: inset 3px 0 0 #1f9d55;
}

.unavailable {
    background-color: #eef1f4;
    opacity: 0.55;
    cursor: not-allowed;
}

.unavailable .layer-btn {
    cursor: not-allowed;
    pointer-events: none;
}

.cursor {
    cursor: pointer;
}
</style>
<script>
import draggable from 'vuedraggable'
import axios from 'axios'
import { orderMapLayers, createLayers } from './../../../utils/utils.js'
import { unByKey } from 'ol/Observable'
import AI_LayerLegend from './AI_LayerLegend.vue'
export default {
    name: 'AI_Featurelist',
    props: [
        'map'
    ],
    components: {
        draggable, AI_LayerLegend
    },
    data() {
        return {
            drtLayersButtonsCtrl: [],
            layersObj: {},
            layerResponse: [],
            olImageLoadStartKey: null,
            olImageLoadEndKey: null,
            olImageLoadErrorKey: null,
            olTileLoadStartKey: null,
            olTileLoadEndKey: null,
            olTileLoadErrorKey: null,
            olSelectkey: null,
            spinnerManager: [],
            shortTermLayerMemory: [],
            legendImgSrc: null,
            layerLegendName: null,
            layerLegend: false,
            layerLegendMaxHeight: null,
            layerLegendMinimized: false,
            layerLegend: false
        }
    },
    methods: {
        getLayerClass(index, element) {
            let mapObjs = this.ai_layersObj
            let disabled = this.checkLayerDisable(element.name, element.zoomControl, element.minZoom)
            let displaying = this.checkLayer(mapObjs[element.name].layer)

            if (!disabled && displaying) {
                // Layer isn't disabled and layer is turned on
                return 'available-enabled'
            } else if (!disabled) {
                // Layer isn't disabled and layer is turned off
                return 'available-not-enabled'
            } else {
                // Layer is disabled
                return 'unavailable'
            }
        },
        checkLayerDisable(layerName, zoomControl, minZoom) {
            /* checkLayerDisable method returns true if zoomControl is
            enabled and the user is zoomed in far enough. */
            let returnClass = false
            let layerExists = this.ai_layersObj[layerName] != null
            let showLayer =
                minZoom == null
                    ? this.map.getView().getZoom() >= 13
                    : this.map.getView().getZoom() >= minZoom

            if (layerExists) {
                const layerObj = this.ai_layersObj[layerName].layer
                if (!this.checkLayer(layerObj)) {
                    /* returnClass is true if zoomControl is enabled on the
                    layer and the user is zoomed in far enough. */
                    returnClass = zoomControl && !showLayer
                }
            }

            return returnClass
        },
        toggleLayer(element, event) {
            let disabled = this.checkLayerDisable(
                element.name,
                element.zoomControl,
                element.minZoom
            )
            let layerName = element.name
            if (!disabled) {
                this.toggleLayerVisibility(layerName)
                this.onEnd()
            }

            event.target.blur();
        },
        onEnd() {
            let mapObjs = this.ai_layersObj
            orderMapLayers(mapObjs, this.drtLayersButtonsCtrl, this.map)
        },
        checkLayer(layer) {
            // Checks if layer exists on the map
            let exists = false
            let mapLayersArr = this.map.getLayers().getArray()

            switch (typeof layer) {
                case 'object':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists = mapLayersArr[i] == layer
                        if (exists) {
                            break
                        }
                    }
                    break
                case 'string':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists =
                            mapLayersArr[i].values_.hasOwnProperty('name') &&
                            mapLayersArr[i].values_.name == layer
                        if (exists) {
                            break
                        }
                    }
                    break
            }

            return exists
        },
        async toTopOfList(elementName) {
            await new Promise((resolve) => {
                this.putLayerOnTop({ payload: { layerName: elementName }, resolve });
            });
        },
        async putLayerOnTop(data) {
            this.drtLayersButtonsCtrl = this.putLayerOnTopHelper(
                this.drtLayersButtonsCtrl,
                data.payload.layerName
            )
            this.onEnd()
        },
        putLayerOnTopHelper(arr, layerName) {
            for (let layerIndex in arr) {
                let layer = arr[layerIndex]
                if (layer.display_name == layerName || layer.name == layerName) {
                    // Removes layer from array
                    arr.splice(layerIndex, 1)
                    // Adds layer back at the beginning of the array
                    arr.unshift(layer)
                    break
                }
            }
            return arr
        },
        async getLayers() {
            if (sessionStorage.token) {
                await axios
                    .get(process.env.API_LOCATION + '/api/spatial_intelligence/getLayers', {
                        method: 'GET',
                        headers: {
                            'x-auth-token': sessionStorage.token
                        }
                    })
                    .then(response => {
                        const content = response.data
                        if (content.errors) {
                            console.log('release API Call Error: ' + content.errors)
                        } else {
                            const layerLinks = []
                            this.drtLayersButtonsCtrl.forEach(layer => {
                                this.unloadLayers(layer.name)
                            })
                            this.drtLayersButtonsCtrl = []
                            this.layerResponse = content
                            content.filter(e => e.visibility != false).forEach(link => {
                                let linkObj = link.link_object
                                let linkObjLayerGroup = linkObj.info.layer_group
                                // Replaces all underscores with spaces
                                let output = linkObj.name.replace(/_/g, ' ')
                                let objToPush = {
                                    name: linkObj.name,
                                    zoomControl: linkObj.zoomControl,
                                    display_name: output,
                                    layer_group: linkObjLayerGroup,
                                    minZoom:
                                        linkObj.minZoom == undefined ? null : linkObj.minZoom,
                                    layer_definition:
                                        linkObj.layerDefinition == undefined
                                            ? null
                                            : linkObj.layerDefinition,
                                    fullMap: linkObj.fullMap
                                }
                                linkObj['display_name'] = output
                                layerLinks.push(linkObj)
                                this.drtLayersButtonsCtrl.push(objToPush)
                            })

                            this.ai_layers = layerLinks
                            this.ai_layersObj = createLayers(this.ai_layers, this.map)

                            this.drtLayersButtonsCtrl.forEach(layerobj => {
                                this.unloadLayers(layerobj.name)
                            })
                            new unByKey(this.olMapMoveStartKey)
                            new unByKey(this.olMapMoveEndKey)
                            this.setListeners()
                        }
                    })
            } else {
                console.log('No User Token')
            }
        },
        setListeners() {
            this.olMapMoveStartKey = this.map.on('movestart', evt => {
                this.lidarIsLoading = true
                this.zoomStarted = this.map.getView().getZoom()
            })
            this.olMapMoveEndKey = this.map.on('moveend', evt => {
                this.zoomControlArr = this.zoomControlLayers(this.ai_layersObj)
                this.zoomEnded = this.map.getView().getZoom()

                // Zoom controlled layer handling
                for (let i in this.zoomControlArr) {
                    let zoomLayer = this.zoomControlArr[i]
                    let layerIndex = this.shortTermLayerMemory.indexOf(
                        zoomLayer.ButtonName
                    )
                    let layerRemembered = layerIndex != -1
                    let item = document.getElementById(zoomLayer.ButtonName)
                    let showLayer =
                        zoomLayer.minZoom == null
                            ? this.map.getView().getZoom() >= 13
                            : this.map.getView().getZoom() >= zoomLayer.minZoom
                    if (item) {
                        // If user is zoomed in enough...
                        if (showLayer) {
                            /* If the layer exists in short term memory,
                            remove it since the layer is being enabled. */
                            if (layerRemembered) {
                                this.toggleLayerVisibility(zoomLayer.ButtonName) // TODO: need this fn eventually
                                this.shortTermLayerMemory.splice(layerIndex, 1)
                            }
                        } else {
                            this.map.getLayers().forEach(layer => {
                                if (layer.get('name') == zoomLayer.ButtonName) {
                                    /* If turning the layer off, add it to short term layer
                                    memory to be enabled again later. */
                                    if (!layerRemembered) {
                                        this.shortTermLayerMemory.push(zoomLayer.ButtonName)
                                    }
                                }
                            })
                            this.unloadLayers(zoomLayer.ButtonName)
                        }
                    }
                }
            })
        },
        zoomControlLayers(layers) {
            let zoomAr = []
            for (let key in layers) {
                if (layers[key].zoomControl) {
                    zoomAr.push({
                        layer: layers[key].layer,
                        ButtonName: key,
                        minZoom:
                            layers[key].minZoom == undefined ? null : layers[key].minZoom
                    })
                }
            }
            return zoomAr
        },
        unloadLayers(layerNameToToggle) {
            let layer
            if (this.ai_layersObj[layerNameToToggle] != null) {
                layer = this.ai_layersObj[layerNameToToggle].layer
            }

            if (layer) {
                // Unloading layer function
                this.map.removeLayer(layer)
                // Removes layer that has been turned off from spinnerManager
                let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
                if (layerIndex != -1) {
                    this.spinnerManager.splice(layerIndex, 1)
                }
            }
        },
        toggleLayerVisibility(layerNameToToggle) {
            if (layerNameToToggle == 'OSM') {
                this.map.getLayers().forEach(layer => {
                    if (layer != undefined && layer.get('name') != undefined) {
                        if (!layer.get('name').includes('OSM')) {
                            this.toggleBaseLayer('Azure')
                        }
                    }
                })
            } else {
                if (this.ai_layersObj.hasOwnProperty(layerNameToToggle)) {
                    const layer = this.ai_layersObj[layerNameToToggle].layer

                    // If the layer doesn't exist on the map, add it to the map
                    if (!this.checkLayer(layer)) {
                        this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)
                        this.map.addLayer(layer)
                        this.getLegend(layerNameToToggle)
                    } else {
                        this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
                    }
                }
            }
        },
        getLegend(layerName) {
            this.map.getLayers().forEach(layer => {
                if (layer.get('name') == layerName) {
                    // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
                    let layerUrl = layer
                        .getSource()
                        .getLegendUrl(this.map.getView().getResolution())
                    if (layerUrl) {
                        this.legendImgSrc = `${layerUrl}&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;` + '&authkey=' + sessionStorage.token
                        this.layerLegendName = layerName
                        // After setting legend URL, show legend component
                        this.layerLegend = true
                    } else {
                        console.log('FAILED TO FIND URL FOR LEGEND.')
                    }
                }
            })
        },
        toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle) {
            /* ImageWMS spinner addition and deletion */
            // Add layer to spinnerManager when image loads/refreshes
            this.olImageLoadStartKey = layer
                .getSource()
                .on('imageloadstart', event => {
                    this.spinnerManager.push(layerNameToToggle)
                })
            // Remove layer from spinnerManager when image finishes loading
            this.olImageLoadEndKey = layer.getSource().on('imageloadend', event => {
                let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
                if (layerIndex != -1) {
                    this.spinnerManager.splice(layerIndex, 1)
                }
            })
            // Remove layer from spinnerManager if image encounters a loading error
            // NOTE - Image Load Error has spelling mistake -- should probably check that the correct event (with spelling mistake) is called
            this.olImageLoadErrorKey = layer
                .getSource()
                .on('imageloadeerror', event => {
                    let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
                    if (layerIndex != -1) {
                        this.spinnerManager.splice(layerIndex, 1)
                    }
                })

            /* TileWMS spinner addition and deletion */
            // Add layer to spinnerManager when tile loads/refreshes
            this.olTileLoadStartKey = layer.getSource().on('tileloadstart', event => {
                this.spinnerManager.push(layerNameToToggle)
            })
            // Remove layer from spinnerManager when tile finishes loading
            this.olTileLoadEndKey = layer.getSource().on('tileloadend', event => {
                let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
                if (layerIndex != -1) {
                    this.spinnerManager.splice(layerIndex, 1)
                }
            })
            // Remove layer from spinnerManager if tile encounters a loading error
            this.olTileLoadErrorKey = layer.getSource().on('tileloaderror', event => {
                let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
                if (layerIndex != -1) {
                    this.spinnerManager.splice(layerIndex, 1)
                }
            })
        },
        toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle) {
            // Removes layer listeners
            new unByKey(this.olImageLoadStartKey)
            new unByKey(this.olImageLoadEndKey)
            new unByKey(this.olImageLoadErrorKey)
            new unByKey(this.olTileLoadStartKey)
            new unByKey(this.olTileLoadEndKey)
            new unByKey(this.olTileLoadErrorKey)
            // Removes layer that has been turned off from spinnerManager
            let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
            while (layerIndex != -1) {
                this.spinnerManager.splice(layerIndex, 1)
                layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
            }
            this.map.removeLayer(layer)
        },
        closeLegend() {
            this.layerLegend = false
        },
        maxOrMinLegend(bool) {
            this.layerLegendMinimized = bool
        },
    },
    mounted() {
        this.getLayers()
    }
}
</script>